import axios from "axios";
import moment from "moment";
import { getTenantDomain } from "../helper";

// What the server prices and books: the property, the stay and the cart.
export const reservationRequest = (id, options, cart) => ({
  upsell: Object.values(cart?.upsell || {}),
  options: {
    ...options,
    arrivalDate: moment(options.arrivalDate).format("YYYY-MM-DD"),
    departureDate: moment(options.departureDate).format("YYYY-MM-DD"),
  },
  properyId: id,
  cart,
});

// The price the server charges for the stay, in cents.
export const fetchBookingPrice = (id, options, tenant, cart) =>
  axios
    .post(`${getTenantDomain(tenant)}/api/iframe/price`, reservationRequest(id, options, cart))
    .then((response) => response.data.price);

// Books the stay and pays it; `expectedAmount` is the total the guest saw, in
// cents, so the server never charges another amount.
export const submitDetailsForm = (
  id,
  userDetails,
  paymentMethodId,
  options,
  tenant,
  cart,
  expectedAmount
) =>
  axios
    .post(`${getTenantDomain(tenant)}/api/iframe/submit-reservation`, {
      ...reservationRequest(id, options, cart),
      userDetails,
      paymentMethodId,
      expectedAmount,
    })
    .then((response) => response.data);

// Finishes a booking whose payment the bank had to verify first.
export const completeReservationPayment = (tenant, paymentIntentId) =>
  axios
    .post(`${getTenantDomain(tenant)}/api/iframe/payments/${paymentIntentId}/complete`)
    .then((response) => response.data);
